import styled from "styled-components";

export const Image = styled.div`
  img {
    display: block;
    max-width: 100%;
    height: auto;
  }

  .thumbnail-image {
    filter: blur(10px);
    transition: opacity 0.5s;
    opacity: 1;
  }

  .fullsize-image {
    transition: opacity 0.5s;
    opacity: 0;
    max-height: 80vh;
    object-fit: contain;
    object-position: center;
  }

  .fullsize-image:not(.hidden) {
    opacity: 1;
    transition: opacity 0.5s;
  }

  .thumbnail-image.hidden {
    transition: opacity 0.5s;
    opacity: 0;
  }
`;



// WEBPACK FOOTER //
// ./app/javascript/bundles/ui/ProgressiveImg/styles.jsx